import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Component({
  selector: 'app-affiliates',
  templateUrl: './affiliates.component.html',
  styleUrls: ['./affiliates.component.scss']
})
export class AffiliatesComponent implements OnInit {

  affiliates: any[] = [];
  displayModal: boolean = false;
  statsModalVisible: boolean = false;
  selectedAffiliate: any = null;

  newReferrer = {
    name: '',
    email: '',
    code: '',
    commissionRate: 10
  };

  constructor(
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,
  ) { }

  ngOnInit(): void {
    this.getAffiliates();
  }

  getAffiliates() {
    this.authenticationService.getReferrers().subscribe({
      next: (response) => {
        const affiliates = (response?.data || []).map((aff: any) => ({
          ...aff,
          name: aff.name || aff.referrerName || 'Unknown',
          email: aff.email || aff.referrerEmail || '',
          commissionRate: Number(aff.commissionRate ?? 0),
          totalClicks: Number(aff.totalClicks ?? 0),
          successfulSubscribers: Number(aff.successfulSubscribers ?? 0),
          eligibleRevenue: Number(aff.eligibleRevenue ?? 0),
          amountDue: Number(aff.amountDue ?? 0),
        }));

        forkJoin(affiliates.map((aff: any) =>
          this.authenticationService.getReferrerStats(aff.userId).pipe(
            catchError(() => of({ data: {} }))
          )
        )).subscribe((stats: any[]) => {
          this.affiliates = affiliates.map((aff: any, index: number) => ({
            ...aff,
            totalReferredUsers: Number(stats[index]?.data?.totalReferredUsers ?? 0),
          }));
        });
      },
      error: (error) => {
        console.error('Failed to load referrers', error);
        this.affiliates = [];
      }
    });
  }

  openAddReferrerModal() {
    this.displayModal = true;
  }

  closeModal() {
    this.displayModal = false;
    this.newReferrer = { name: '', email: '', code: '', commissionRate: 10 };
  }

  submitReferrer() {
    const payload = {
      name: this.newReferrer.name?.trim(),
      email: this.newReferrer.email?.trim(),
      customCode: this.newReferrer.code?.trim(),
      commissionRate: Number(this.newReferrer.commissionRate ?? 10),
    };

    if (!payload.name || !payload.email) {
      this.toastr.error('Name and email are required to generate a referrer.');
      return;
    }

    this.authenticationService.generateReferrer(payload).subscribe({
      next: (response) => {
        this.toastr.success(response?.message || 'Referrer generated successfully');
        this.getAffiliates();
        this.closeModal();
      },
      error: (error) => {
        const message = error?.error?.message || 'Unable to create referrer';
        this.toastr.error(message);
      }
    });
  }

  payAffiliate(id: string) {
    if (confirm('Are you sure you want to mark all pending commissions for this affiliate as Paid?')) {
      const aff = this.affiliates.find(a => a._id === id);
      if (aff) {
        this.authenticationService.markAffiliateCommissionsAsPaid(id).subscribe({
          next: (response) => {
            this.toastr.success(response?.message || 'Commissions marked as paid successfully');
            aff.amountDue = 0.00;
            this.getAffiliates();
          },
          error: (error) => {
            const message = error?.error?.message || 'Failed to mark commissions as paid';
            this.toastr.error(message);
          }
        });
      }
    }
  }

  openStatsModal(id: string) {
    const aff = this.affiliates.find(a => a._id === id);
    this.selectedAffiliate = aff || null;
    this.statsModalVisible = true;
  }

  closeStatsModal() {
    this.statsModalVisible = false;
    this.selectedAffiliate = null;
  }

  viewStats(id: string) {
    this.openStatsModal(id);
  }
}
